declare global {
    interface Window { REACT_APP_API_HOST: any; REACT_APP_API_BASE_PATH: any; REACT_APP_AUTH_MODE: any; }
}

export const config = {
    apiUrl: window.REACT_APP_API_HOST || process.env.REACT_APP_API_HOST,
    basePath: window.REACT_APP_API_BASE_PATH || process.env.REACT_APP_API_BASE_PATH,
    authMode: window.REACT_APP_AUTH_MODE || process.env.REACT_APP_AUTH_MODE,
};
